import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, doc, updateDoc, addDoc, setDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../../contexts/UserContext';

// Fonction pour convertir le texte brut en HTML
const convertToHTML = (text) => {
    return text
        .replace(/\n/g, '<br/>')
        .replace(/\s\s/g, '&nbsp;');
};

const Emails = () => {
    const [emails, setEmails] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false); // Pour ajouter un email
    const [newEmail, setNewEmail] = useState({ objet: '', texte: '', texte2: '' });
    const { user } = useContext(UserContext);

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                const emailsCollection = collection(db, 'email');
                const emailsSnapshot = await getDocs(emailsCollection);
                let emailsList = emailsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setEmails(emailsList);
            } catch (error) {
                console.error("Error fetching emails: ", error);
            }
        };

        fetchEmails();
    }, []);

    // --- Edition ---
    const handleShowEdit = (email) => {
        setSelectedEmail(email);
        setShowEditModal(true);
    };

    const handleSave = async () => {
        try {
            const emailDoc = doc(db, 'email', selectedEmail.id);
            await updateDoc(emailDoc, {
                objet: selectedEmail.objet,
                texte: convertToHTML(selectedEmail.texte),
                texte2: convertToHTML(selectedEmail.texte2),
            });
            setEmails(prev => prev.map(e => e.id === selectedEmail.id ? selectedEmail : e));
            setShowEditModal(false);
        } catch (error) {
            console.error('Error updating email: ', error);
        }
    };

    const handleChange = (e, isNew = false) => {
        const { name, value } = e.target;
        if (isNew) {
            setNewEmail(prev => ({ ...prev, [name]: value }));
        } else {
            setSelectedEmail(prev => ({ ...prev, [name]: value }));
        }
    };

    // --- Ajout ---
    const handleAdd = async () => {
        try {
            const docRef = await addDoc(collection(db, 'email'), {
                ...newEmail,
                texte: convertToHTML(newEmail.texte),
                texte2: convertToHTML(newEmail.texte2),
            });
            setEmails(prev => [...prev, { ...newEmail, id: docRef.id }]);
            setNewEmail({ objet: '', texte: '', texte2: '' });
            setShowAddModal(false);
        } catch (error) {
            console.error("Error adding email: ", error);
        }
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Gestion des Email envoyés au client</h6>
                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                <button className="btn btn-success" onClick={() => setShowAddModal(true)}>
                                    <FontAwesomeIcon icon={faPlus} /> Ajouter un Email
                                </button>
                            )}
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>id</th>
                                            <th>Objet</th>
                                            <th>Contenu avant informations</th>
                                            <th>Contenu après informations</th>
                                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {emails.map((email) => (
                                            <tr key={email.id}>
                                                <td>{email.id}</td>
                                                <td>{email.objet}</td>
                                                <td>{email.texte}</td>
                                                <td>{email.texte2}</td>
                                                {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                    <td>
                                                        <button className="btn btn-primary btn-sm ml-2" onClick={() => handleShowEdit(email)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Edition */}
            {showEditModal && selectedEmail && (
                <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Modifier Email</h5>
                                <button type="button" className="close" onClick={() => setShowEditModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label>Objet</label>
                                        <input type="text" name="objet" className="form-control" value={selectedEmail.objet} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Contenu avant informations</label>
                                        <textarea name="texte" className="form-control" rows="4" value={selectedEmail.texte} onChange={handleChange}></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label>Contenu après informations</label>
                                        <textarea name="texte2" className="form-control" rows="4" value={selectedEmail.texte2} onChange={handleChange}></textarea>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Fermer</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Sauvegarder</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Ajout */}
           {/* Modal Ajout */}
{showAddModal && (
    <div className="modal show" style={{ display: 'block' }}>
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Ajouter un Email</h5>
                    <button type="button" className="close" onClick={() => setShowAddModal(false)}>
                        <span>&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <form>
                        <div className="form-group">
                            <label>ID</label>
                            <input
                                type="text"
                                name="id"
                                className="form-control"
                                value={newEmail.id || ''}
                                onChange={(e) => handleChange(e, true)}
                                placeholder="Choisir un ID unique"
                            />
                        </div>
                        <div className="form-group">
                            <label>Objet</label>
                            <input
                                type="text"
                                name="objet"
                                className="form-control"
                                value={newEmail.objet}
                                onChange={(e) => handleChange(e, true)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Contenu avant informations</label>
                            <textarea
                                name="texte"
                                className="form-control"
                                rows="4"
                                value={newEmail.texte}
                                onChange={(e) => handleChange(e, true)}
                            ></textarea>
                        </div>
                        <div className="form-group">
                            <label>Contenu après informations</label>
                            <textarea
                                name="texte2"
                                className="form-control"
                                rows="4"
                                value={newEmail.texte2}
                                onChange={(e) => handleChange(e, true)}
                            ></textarea>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Fermer</button>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={async () => {
                            try {
                                if (!newEmail.id) {
                                    alert("Veuillez entrer un ID !");
                                    return;
                                }
                                const docRef = doc(db, "email", newEmail.id);
                                await setDoc(docRef, {
                                    ...newEmail,
                                    docId: newEmail.id,
                                    texte: convertToHTML(newEmail.texte),
                                    texte2: convertToHTML(newEmail.texte2),
                                });
                                setEmails(prev => [...prev, { ...newEmail, id: newEmail.id }]);
                                setNewEmail({ objet: '', texte: '', texte2: '', id: '' });
                                setShowAddModal(false);
                            } catch (error) {
                                console.error("Error adding email: ", error);
                            }
                        }}
                    >
                        Ajouter
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

        </div>
    );
};

export default Emails;
